// src/pages/Unsubscribe.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const Unsubscribe = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        const response = await fetch(`/api/subscriptions/unsubscribe/${token}`);
        if (response.ok) {
          setStatus('success');
        } else {
          const errorData = await response.json();
          throw new Error(errorData.error || 'Failed to unsubscribe');
        }
      } catch (error) {
        console.error('Unsubscribe error:', error);
        setError(error.message || 'An error occurred while processing your request');
        setStatus('error');
      }
    };

    if (token) {
      unsubscribe();
    } else {
      setError('Invalid unsubscribe link');
      setStatus('error');
    }
  }, [token]);

  return (
    <div className="container mx-auto px-4 py-32 max-w-md">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          {status === 'processing' && (
            <>
              <div className="mb-4">
                <svg className="animate-spin h-12 w-12 text-blue-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-gray-800 mb-4">Processing Your Request</h1>
              <p className="text-gray-600">Please wait while we process your unsubscribe request...</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="mb-4 text-green-500">
                <svg className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-gray-800 mb-4">Successfully Unsubscribed</h1>
              <p className="text-gray-600 mb-6">You have been successfully unsubscribed from our newsletter.</p>
              <p className="text-gray-500">We're sorry to see you go! If you change your mind, you can always subscribe again.</p>
              <div className="mt-8">
                <a href="/" className="text-blue-600 hover:text-blue-800 font-medium">Return to Homepage</a>
              </div>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="mb-4 text-red-500">
                <svg className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-gray-800 mb-4">Error</h1>
              <p className="text-gray-600 mb-6">{error}</p>
              <div className="mt-8">
                <a href="/" className="text-blue-600 hover:text-blue-800 font-medium">Return to Homepage</a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;